import { FileUploadPrepareRequest, FileUploadPrepareResponse } from "../../interfaces/file/FileUpload"; // Assuming these interfaces will be created

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Function to prepare a file upload (get SAS token)
export async function prepareFileUpload(
  authToken: string,
  fileMetadata: FileUploadPrepareRequest
): Promise<FileUploadPrepareResponse | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/file/prepare-upload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(fileMetadata),
    });

    if (!response.ok) {
      console.error(`Failed to prepare file upload:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`Error preparing file upload:`, error);
    return null;
  }
}

// Function to upload the file to the provided SAS URL
export async function uploadFileToAzure(
  uploadUrl: string,
  file: File,
  contentType: string
): Promise<boolean> {
  try {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': contentType,
      },
      body: file,
    });

    if (!response.ok) {
      console.error(`Failed to upload file to Azure:`, response.status, response.statusText);
      return false;
    }

    return true;
  } catch (error) {
    console.error(`Error uploading file to Azure:`, error);
    return false;
  }
}
